module.exports = __webpack_public_path__ + "static/media/md-remove-circle-outline.18bdbaa3.svg";